import { Routes, Route } from "react-router-dom";
import { useUserStore } from "../store/userStore";
import PrivateRoutes from "./PrivateRoutes";

import NotFound from "../Pages/NotFound/NotFound";
import Main from "../Pages/Main/Main";
import Registration from "../Pages/Registration/Registration";
import ScheduleProvider from "../Pages/ScheduleProvider";
import ScheduleConsumer from "../Pages/ScheduleConsumer/ScheduleConsumer";
import Bills from "../Pages/Bills";
import Customres from "../Pages/Customers/Customers";
import EditSchedule from "../Pages/EditSchedule";
import Invitation from "../Pages/Invitation/Invitation";
import ScheduleDetails from "../Pages/ScheduleDetails/ScheduleDetails";
import SessionDetails from "../Pages/SessionDetails/SessionDetails";
import InvitedSignIn from "../Pages/InvitedSignIn/InvitedSignIn";
import Reschedule from "../Pages/Reschedule";
import Profile from "../Pages/Profile/Profile";
import ProviderGroups from "../Pages/ProviderGroups";
import RegiterMethodSelector from "../Pages/RegiterMethodSelector";
import UserRoleSelector from "../Pages/UserRoleSelector/UserRoleSelector";
import ProviderRegistration from "../Pages/ProviderRegistration/ProviderRegistration";
import ProviderHistory from "../Pages/ProviderHistory/ProviderHistory";
import ConsumerHistory from "../Pages/ConsumerHistory/ConsumerHistory";
import ProviderByscheduleHistoryDetails from "../Pages/ProviderByscheduleHistoryDetails/ProviderByscheduleHistoryDetails";
import ProviderHistoryAttender from "../Pages/ProviderHistoryAttender/ProviderHistoryAttender";
import ProviderBycustomerHistoryDetails from "../Pages/ProviderBycustomerHistoryDetails/ProviderBycustomerHistoryDetails";
import ConsumerBycustomerHistoryDetails from "../Pages/ConsumerBycustomerHistoryDetails/ConsumerBycustomerHistoryDetails";
import Finances from "../Pages/Finances/Finances";
import InvoiceDetails from "../Pages/InvoiceDetails/InvoiceDetails";
import Clubs from "../Pages/Clubs/Clubs";
import CreateSchedule from "../Pages/CreateSchedule";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import ResetPasswordLink from "../Pages/ResetPasswordLink/ResetPasswordLink";
import InvitedSignUpLink from "../Pages/InvitedSignUpLink/InvitedSignUpLink";
import ConsumerClasses from "../Pages/ConsumerClasses/ConsumerClasses";
import ConsumerSessionDetails from "../Pages/ConsumerSessionDetails/ConsumerSessionDetails";
import FbCallback from "../Pages/FbCallback";
import FindProvider from "../Pages/FindProvider/FindProvider";
import FindProviderReasult from "../Pages/FindProviderReasult/FindProviderReasult";
import FindProviderDetails from "../Pages/FindProviderDetails/FindProviderDetails";
import ProviderRequests from "../Pages/ProviderRequests/ProviderRequests";
import ConsumerRequests from "../Pages/ConsumerRequests/ConsumerRequests";

const Router = () => {
  const { user } = useUserStore();

  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="/reset-password" element={<ResetPasswordLink />} />

      <Route path="/register" element={<RegiterMethodSelector />} />
      <Route path="/role-selector" element={<UserRoleSelector />} />
      <Route
        path="/role-selector/consumer-registration"
        element={<Registration />}
      />
      <Route
        path="/role-selector/provider-registration"
        element={<ProviderRegistration />}
      />
      <Route path="/signIn" element={<InvitedSignIn />} />
      <Route path="/signUp" element={<InvitedSignUpLink />} />
      <Route path="/facebook-callback/:authType" element={<FbCallback />} />
      <Route path="/usedInv" element={<Main />} />
      <Route path="*" element={<NotFound />} />
      <Route element={<PrivateRoutes />}>
        <Route path="/profile" element={<Profile />} />
        <Route
          path="/sessions"
          element={
            <>
              {user?.type === "Consumer" && <ScheduleConsumer />}
              {user?.type === "Provider" && <ScheduleProvider />}
            </>
          }
        />
        <Route
          path="/schedules"
          element={
            user?.type === "Provider" ? <ProviderGroups /> : <NotFound />
          }
        />
        <Route
          path="/my-classes"
          element={
            user?.type === "Consumer" ? <ConsumerClasses /> : <NotFound />
          }
        />
        <Route
          path="/my-classes/:classID"
          element={
            user?.type === "Consumer" ? (
              <ConsumerSessionDetails />
            ) : (
              <NotFound />
            )
          }
        />
        <Route path="/bills" element={<Bills />} />
        <Route path="/customers" element={<Customres />} />
        <Route
          path="/invite"
          element={
            user?.type === "Provider" ? <CreateSchedule /> : <NotFound />
          }
        />
        <Route
          path="/invitation"
          element={user?.type === "Consumer" ? <Invitation /> : <NotFound />}
        />
        <Route
          path="/schedule/:scheduleID"
          element={
            user?.type === "Provider" ? <ScheduleDetails /> : <NotFound />
          }
        />
        <Route
          path="/schedule/edit/:scheduleId"
          element={user?.type === "Provider" ? <EditSchedule /> : <NotFound />}
        />
        <Route
          path="/session/:sessionID"
          element={
            user?.type === "Provider" ? <SessionDetails /> : <NotFound />
          }
        />
        <Route
          path="/reschedule/:scheduleID"
          element={user?.type === "Provider" ? <Reschedule /> : <NotFound />}
        />
        <Route
          path="/history/byschedule"
          element={
            user?.type === "Provider" ? <ProviderHistory /> : <NotFound />
          }
        />
        <Route
          path="/history/bycustomer"
          element={
            user?.type === "Provider" ? <ProviderHistory /> : <NotFound />
          }
        />
        <Route
          path="/history/byschedule/:byscheduleId"
          element={
            user?.type === "Provider" ? (
              <ProviderByscheduleHistoryDetails />
            ) : (
              <NotFound />
            )
          }
        />
        <Route
          path="/history/byschedule/:byscheduleId/:subscriberId"
          element={
            user?.type === "Provider" ? (
              <ProviderHistoryAttender />
            ) : (
              <NotFound />
            )
          }
        />
        <Route
          path="/history/bycustomer/:bycustomerId"
          element={
            user?.type === "Provider" ? (
              <ProviderBycustomerHistoryDetails />
            ) : (
              <ConsumerBycustomerHistoryDetails />
            )
          }
        />
        <Route
          path="/history"
          element={
            user?.type === "Consumer" ? <ConsumerHistory /> : <NotFound />
          }
        />
        <Route
          path="/finances"
          element={user?.type === "Provider" ? <Finances /> : <NotFound />}
        />
        <Route
          path="/requests"
          element={
            user?.type === "Provider" ? <ProviderRequests /> : <NotFound />
          }
        />
        <Route path="/finances/:externalId" element={<InvoiceDetails />} />
      </Route>
      <Route
        path="/clubs"
        element={user?.type === "Consumer" ? <FindProvider /> : <NotFound />}
      />

      <Route
        path="/search-results"
        element={
          user?.type === "Consumer" ? <FindProviderReasult /> : <NotFound />
        }
      />
      <Route
        path="/search-results/:providerId"
        element={
          user?.type === "Consumer" ? <FindProviderDetails /> : <NotFound />
        }
      />
      <Route
        path="/sent-requests"
        element={
          user?.type === "Consumer" ? <ConsumerRequests /> : <NotFound />
        }
      />
    </Routes>
  );
};

export default Router;
